import React, { useState } from "react";
import { Box } from "../../assets/ui";
import { CloseIcon, UploadIcon, PlusIcon } from "../../assets/icons";
import styled from "styled-components";
import {deleteMedia, sendData} from "../../api";
import Theme from "../../assets/ui/theme";
import {ClipLoader} from "react-spinners";

const StyledUploader = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 280px;
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.08);
  padding: 25px 32px;
  border-radius: 8px;
  
  & h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 14px;
    color: #233247;
  }
  & h4 {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 15px;
    margin: 12px 0 26px;
    text-align: center;
    color: #96a8be;
  }
  
  & .img-wrapper {
    border-radius: ${({ isRound }) => (isRound ? "50%" : "8px")};
    border: 1px solid ${({ isRound }) => (isRound ? "transparent" : "#B8BDC4")};
    width: 80px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
  
  & .remove {
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.16);
    background: #fff;
    width: 24px;
    cursor: pointer;
    height: 24px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    right: 0;
  }
  & .upload-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(237, 49, 99, 0.08);
    box-shadow: inset 0px 2px 0px rgba(255, 255, 255, 0.06);
    border-radius: 24px;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: #ed3163;
    cursor: pointer;
    padding: 6px 20px 6px 6px;
    
    & > span {
      width: 32px;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #ed3163;
      border-radius: 50%;
      margin-right: 16px;
    }
  }
  
  & img {
    width: 100%;
    height: auto;
  }
  
  & > .uploader {
    width: 80px;
    height: 80px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #feeff3;
    mix-blend-mode: normal;
    border: 1px dashed #ed3163;
    border-radius: ${({ isRound }) => (isRound ? "50%" : "8px;")};

    & > input {
      display: none;
    }
  }
`;

const Uploader = ({
  setFilePath,
  acceptFiles,
  title,
  isRound,
  filePath,
  description
}) => {
  const [img, setImg] = useState(null);
  const [uploading, setUploading] = useState(false);

  const removeFile = () => {
    setImg(null);
    setFilePath(null);
      deleteMedia(`mailService/mails/work/media`, {filePath}).then(res => {
          console.log(res);
      })
  };
  const sendFile = data => {
    sendData(
      "mailService/mails/work/media",
      data
    ).then(res => {
        setUploading(false);
      res && res.filePath && setFilePath(res.filePath);
    });
  };

  const onChangeFile = e => {
      const file = e.target.files[0];
      setUploading(true)
      sendFile(e.target.files);

      if (file.type === "image/png" || file.type === "image/jpeg") {
          const reader = new FileReader();
          reader.onload = function(e) {
              setImg(e.target.result);
          };

          reader.readAsDataURL(file);
      } else {
          setImg("/images/cv-mock.png");
      }
  };
  return (
    <StyledUploader isRound={isRound}>
      <h3>{title}</h3>
      {uploading
          ? <Box width="80px" height="80px">
              <ClipLoader
                  sizeUnit={"px"}
                  size={80}
                  color={Theme.colors.mainPink}
                  loading={true}
              />
          </Box>

          : img ? (
        <Box position="relative" width="fit-content">
          <div className="img-wrapper">
            <img src={img} alt="" />
          </div>
          <button className="remove" onClick={removeFile}>
            <CloseIcon />
          </button>
        </Box>
      ) : (
        <label className="uploader">
          <PlusIcon />
          <input
            id="uploader"
            type="file"
            accept={acceptFiles}
            onChange={onChangeFile}
          />
        </label>
      )}

      <h4>{description}</h4>
      <label htmlFor="uploader" className="upload-btn">
        {" "}
        <span>
          <UploadIcon />{" "}
        </span>
        Select file
      </label>
    </StyledUploader>
  );
};

export default Uploader;
